import { render, staticRenderFns } from "./entityExtraction.vue?vue&type=template&id=496605f4&scoped=true"
import script from "./entityExtraction.vue?vue&type=script&lang=js"
export * from "./entityExtraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496605f4",
  null
  
)

export default component.exports